import React from 'react';
import classnames from 'classnames';
import * as styles from './base.scss';
function href(name) {
    return `/styles/images/mm-icons.svg#mm-icon-${name}`;
}
export function GetIcons(name) {
    name = name.toLowerCase();
    if (name.startsWith('mina fakturor')) {
        return 'accounting';
    }
    else if (name.startsWith('favoritlistor')) {
        return 'favorite';
    }
    else if (name.startsWith('intranät')) {
        return 'intranet';
    }
    else if (name.startsWith('inventering')) {
        return 'inventory';
    }
    else if (name.startsWith('mina kampanjer') || name.startsWith('kampanjer') || name.startsWith('erbjudanden')) {
        return 'campaign';
    }
    else if (name.startsWith('översikt')) {
        return 'overview';
    }
    else if (name.startsWith('pantretur')) {
        return 'pantReturns';
    }
    else if (name.startsWith('reklamationer')) {
        return 'complaints';
    }
    else if (name.startsWith('statistik')) {
        return 'overview';
    }
    else if (name.startsWith('order')) {
        return 'order';
    }
    else if (name.startsWith('leveranser')) {
        return 'deliveries';
    }
    else if (name.startsWith('min profil')) {
        return 'user';
    }
    else if (name.startsWith('användarkonton')) {
        return 'settings';
    }
    else if (name.startsWith('retur')) {
        return 'returnSRS';
    }
    else if (name.startsWith('admin')) {
        return 'admin';
    }
    else if (name.startsWith('impersonering')) {
        return 'impersonate';
    }
    else if (name.startsWith('mitt upplägg')) {
        return 'arrangement';
    }
    else if (name.startsWith('utvalt')) {
        return 'alwaysAffordable';
    }
    else if (name.startsWith('egna varor')) {
        return 'customProducts';
    }
    else if (name.startsWith('recept & kalkyl')) {
        return 'recipe';
    }
    else if (name.startsWith(''))
        return null;
}
const MyMenigoIcon = ({ name, className, onClick }) => {
    return (React.createElement("svg", { className: classnames(styles.mmicon, className), onClick: onClick },
        React.createElement("use", { href: href(name) })));
};
export default MyMenigoIcon;
